import * as React from 'react';
import makeIcon from './make_icon';
import { jsx as ___EmotionJSX } from "@emotion/core";
var roundFilled = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.8536 6.14645C21.0488 6.34171 21.0488 6.65829 20.8536 6.85355L9.35355 18.3536C9.15829 18.5488 8.84171 18.5488 8.64645 18.3536L3.14645 12.8536C2.95118 12.6583 2.95118 12.3417 3.14645 12.1464C3.34171 11.9512 3.65829 11.9512 3.85355 12.1464L9 17.2929L20.1464 6.14645C20.3417 5.95118 20.6583 5.95118 20.8536 6.14645Z"
});
var roundLined = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.8536 6.14645C21.0488 6.34171 21.0488 6.65829 20.8536 6.85355L9.35355 18.3536C9.15829 18.5488 8.84171 18.5488 8.64645 18.3536L3.14645 12.8536C2.95118 12.6583 2.95118 12.3417 3.14645 12.1464C3.34171 11.9512 3.65829 11.9512 3.85355 12.1464L9 17.2929L20.1464 6.14645C20.3417 5.95118 20.6583 5.95118 20.8536 6.14645Z"
});
var sharpFilled = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.2071 6.50008L9.00001 18.7072L2.79291 12.5001L3.50001 11.793L9.00001 17.293L20.5 5.79297L21.2071 6.50008Z"
});
var sharpLined = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.2071 6.50008L9.00001 18.7072L2.79291 12.5001L3.50001 11.793L9.00001 17.293L20.5 5.79297L21.2071 6.50008Z"
});
var IconCheckmark = makeIcon('IconCheckmark', 'Checkmark', false, {
  roundFilled,
  roundLined,
  sharpFilled,
  sharpLined
});
export default IconCheckmark;